import React from 'react';
import './App.css';
import WeatherForecast from './WeatherForecast';

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      input: '',
      city: '',
      url: '',
      weather: '',
      temp: '',
      wind: '',
      flag: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.getData = this.getData.bind(this);
    this.handleErrors = this.handleErrors.bind(this);

  }

  handleChange(event) {
    this.setState({
      input: event.target.value,
      flag: false
    });
  }


  handleSubmit(event) {
    event.preventDefault();
    const url = "https://api.openweathermap.org/data/2.5/weather?q=" + this.state.input + "&appid=ba4eac3926cb7d59a3b93b6cd25a2bee";
    this.setState({
      input: '',
      city: this.state.input
    });
    this.getData(url);
    
    console.log(this.state.flag,'flag')
  }

  getData(url) {
    fetch(url)
    .then(this.handleErrors)
    .then((resp) => {
      resp.json()
      .then((res) => {              
        this.setState({
          weather: res.weather,
          temp: res.main,
          wind: res.wind,            
        })
      })
    })   
    //.then(response =>response.json()) 
  }

  handleErrors(response) {
    if (!response.ok) {
      this.setState({
        flag: true
      })
      return response
    } 
    else {
      return response
    }  
};

  render() {
    console.log(this.state.flag,'flag2')         
    if (this.state.flag===true) {
      return (
        <div className="body">
        <div className="quote-box">
          <form onSubmit={this.handleSubmit}>
            <input
              value={this.state.input}
              onChange={this.handleChange}
              placeholder="Enter the city ..." />
            <button type='submit'>
              Search
          </button>
          </form>
          <p>
            Could not load data. <br /> <br/>Please check that you've entered a valid city.
          </p>
        </div>
      </div>
      )
    }
    else {
      return (
        <div className="body">
          <div className="quote-box">
            <form onSubmit={this.handleSubmit}>
              <input
                value={this.state.input}
                onChange={this.handleChange}
                placeholder="Enter the city ..." />
              <button type='submit'>
                Search
            </button>
            </form>
            <WeatherForecast city={this.state.city} weather={this.state.weather} temp={this.state.temp} wind={this.state.wind} />
          </div>
        </div>
      );
    }
  }
};


export default App;


